import { useTranslation } from 'react-i18next';
import {
  BarChartOutlined,
  DollarOutlined,
  EyeOutlined,
  LinkOutlined,
  RiseOutlined,
  UserOutlined,
} from '@ant-design/icons';

import { StatCard } from './components';
import { CardListBannerProps } from './types';

import { formatNumber } from 'features/helpers/formatNumber';
import { roundToNearestAfterDecimal } from 'features/helpers/helpers';
import { generalSummaryBanner } from 'features/helpers/statistics/generalSummaryBanner';

export const CardListBanner = ({ rangeDate, statistics }: CardListBannerProps) => {
  const { t } = useTranslation('stats-for-client');
  const summary = generalSummaryBanner(statistics, rangeDate.startDate, rangeDate.endDate);
  const showClicks = !!summary.totalClicks;

  const blockStyle = showClicks
    ? `grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-5`
    : `grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-4 mb-5`;

  return (
    <div className={blockStyle}>
      <StatCard
        icon={<UserOutlined />}
        color="#4F46E5"
        topTitle="Каналов"
        topValue={formatNumber(roundToNearestAfterDecimal(summary.totalChannels || 0))}
        bottomTitle="подписчиков"
        bottomValue={formatNumber(summary.totalParticipants || 0)}
        tooltip="Общее количество каналов и подписчиков"
      />

      <StatCard
        icon={<BarChartOutlined />}
        color="#10B981"
        topTitle="% баннеров"
        topValue={`${formatNumber(roundToNearestAfterDecimal((summary.totalPostsWithBanner / summary.totalPosts) * 100 || 0))}%`}
        bottomTitle="постов с баннером"
        bottomValue={formatNumber(summary.totalPostsWithBanner || 0)}
        tooltip="Процент баннеров в постах и всего баннеров"
      />

      <StatCard
        icon={<EyeOutlined />}
        color="#F59E0B"
        topTitle={t('percentage_views')}
        topValue={`${formatNumber(roundToNearestAfterDecimal(summary.bannerViewPercentage || 0))}%`}
        bottomTitle="просмотров"
        bottomValue={formatNumber(summary.totalViews || 0)}
        tooltip="Процент подписчиков, которые посмотрели баннер и всего просмотров"
      />

      {showClicks && (
        <StatCard
          icon={<LinkOutlined />}
          color="#EC4899"
          topTitle={t('percentage_clicks')}
          topValue={`${formatNumber(roundToNearestAfterDecimal(summary.clickPercentage || 0))}%`}
          bottomTitle="кликов"
          bottomValue={formatNumber(summary.totalClicks || 0)}
          tooltip="Процент переходов по ссылке и всего кликов"
        />
      )}

      <StatCard
        icon={<DollarOutlined />}
        color="#6366F1"
        topTitle="CPM"
        topValue={formatNumber(summary.cpmViews || 0)}
        bottomTitle="в среднем просмотров"
        bottomValue={`${formatNumber(roundToNearestAfterDecimal(summary.totalViews / summary.totalParticipants || 0))}`}
        tooltip="Стоимость 1000 показов"
      />

      {showClicks && (
        <StatCard
          icon={<RiseOutlined />}
          color="#8B5CF6"
          topTitle="CPC"
          topValue={formatNumber(summary.cpcClicks || 0)}
          bottomTitle="в среднем кликов у канала"
          bottomValue={`${formatNumber(roundToNearestAfterDecimal(summary.totalClicks / summary.totalChannels || 0))}`}
          tooltip="Стоимость перехода по ссылке"
        />
      )}
    </div>
  );
};
